import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const EggIcon = ({
  innerColor = '#fefefe',
  outerColor = '#f39339',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: innerColor,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_118"
        data-name="Grupo 118"
        transform="translate(-282.5 -2094)"
      >
        <g
          id="Rectángulo_21"
          data-name="Rectángulo 21"
          transform="translate(282.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="boiled-egg" transform="translate(288.366 2100.307)">
          <path
            id="Trazado_9111"
            data-name="Trazado 9111"
            d="M15.264,22.357a12.672,12.672,0,0,0-.242-2.246.3.3,0,0,0-.593.123,12.067,12.067,0,0,1,.229,2.138,7.072,7.072,0,0,1-.566,3.159,4.608,4.608,0,0,1-3.41,2.585,4.987,4.987,0,0,1-1.71-.077A5.717,5.717,0,0,0,10.34,26.8a6.909,6.909,0,0,0,.835-6.269,11.525,11.525,0,0,0-1.745-3.76,3.281,3.281,0,0,1,2.243-.393l.021.006A3.385,3.385,0,0,1,13.591,18a.3.3,0,0,0,.516-.317,4,4,0,0,0-2.271-1.893,3.947,3.947,0,0,0-2.795.5,4.809,4.809,0,0,0-2.93-1.739,3.8,3.8,0,0,0-2.428.706,6.5,6.5,0,0,0-1.761,1.79A12.018,12.018,0,0,0,.374,20.531,6.909,6.909,0,0,0,1.209,26.8a5.509,5.509,0,0,0,2.16,1.658,6.455,6.455,0,0,0,4.814,0,5.568,5.568,0,0,0,2.6.257,5.094,5.094,0,0,0,3.852-2.908,7.647,7.647,0,0,0,.631-3.449ZM3.614,27.9l-.023-.01A4.962,4.962,0,0,1,1.666,26.4a6.324,6.324,0,0,1-.709-5.7c.833-2.932,2.1-4.286,3.02-4.906a3.511,3.511,0,0,1,1.763-.648h.047c.032,0,3.211-.06,4.806,5.555a6.324,6.324,0,0,1-.709,5.7,4.962,4.962,0,0,1-1.925,1.493,5.881,5.881,0,0,1-4.345.01Z"
            transform="translate(0 -14.537)"
          />
          <path
            id="Trazado_9112"
            data-name="Trazado 9112"
            d="M87.961,210.286a3.315,3.315,0,0,0-3.311-3.311,3.28,3.28,0,0,0-1.458.338.3.3,0,0,0,.267.544,2.679,2.679,0,0,1,1.191-.276,2.7,2.7,0,1,1-2.586,1.907.3.3,0,0,0-.579-.178,3.312,3.312,0,1,0,6.476.977Z"
            transform="translate(-78.876 -201.147)"
          />
          <path
            id="Trazado_9113"
            data-name="Trazado 9113"
            d="M105.271,243.221a.3.3,0,1,0,.105-.363A.305.305,0,0,0,105.271,243.221Z"
            transform="translate(-102.061 -235.891)"
          />
          <path
            id="Trazado_9114"
            data-name="Trazado 9114"
            d="M464.211,151.61a.3.3,0,1,0,.381-.106A.3.3,0,0,0,464.211,151.61Z"
            transform="translate(-450.104 -147.329)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default EggIcon;
